import { mapState } from 'vuex';
export default {
  name: 'NoticeUploadInsuranceTemplate',
  data() {
    return {
      visible: false
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  watch: {
    accountInfo: {
      handler(newVal) {
        this.visible = this.accountInfo.documentUploaded && this.accountInfo.insuranceNotice;
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.visible = false;
    }
  }
};